"use client";

import CommonImage from "@/components/common/image/CommonImage";
import { Modal } from "antd";
import { motion } from "framer-motion";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { FaCirclePlay } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import VimeoPlayer from "@/components/common/Player/VimeoPlayer";
import CourseVideo from "@/components/common/Player/CourseVideo";
import YoutubePlayer from "@/components/common/Player/YoutubePlayer";
import { getYoutubeThumbnailUrl } from "@/utils/youtube";
import Link from "next/link";
import SkeletonHeroSection from "@/components/common/skeletons/SkeletonHeroSection";
export default function HeroSection({banner_features=[],setting=null}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
  const [loading, setLoading] = useState(false);

  return (
    <>
      {/* {loading ? (
        <SkeletonHeroSection />
      ) : ( */}
      <section className="hero-section section_short-padding">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 hero-content">
            <div className="left-part">
              <div className="hero-text">
                <h1 className="main-title">
                  {" "}
                  <span className="highlighted">
                    {setting?.banner_heading_red}
                  </span>{" "}
                  {setting?.banner_heading_blue}
                </h1>
                <h4 className="main-subtitle">
                  {setting?.banner_sub_heading}{" "}
                </h4>
              </div>
              <div className="hero-image">
                <div className="hero-features">
                  {banner_features?.map((banner_feature, index) => (
                    <div className="feature-item" key={index}>
                      <CommonImage
                        src={banner_feature?.icon_url}
                        alt={banner_feature?.title || "Feature Icon"}
                        width={50}
                        height={50}
                        className="feature-icon"
                      />
                      <h4 className="feature-title">{banner_feature.title}</h4>
                    </div>
                  ))}
                </div>
              </div>
              <div className="hero-btns">
                <Link
                  href="/courses/all"
                  className="primary-btn hero-primary-btn"
                >
                  <Image
                    src="/images/home-page/enlighten-book.avif"
                    alt="Icon"
                    width={20}
                    height={20}
                    className="btn-icon"
                  />
                  সকল কোর্স
                </Link>
                {setting?.trendy_button_title && (
                  <a href={setting?.trendy_button_link} className="btn-outline">
                    <Image
                      src="/images/home-page/enlighten-book.avif"
                      alt="Icon"
                      width={20}
                      height={20}
                      className="btn-icon"
                    />
                    {setting.trendy_button_title}
                  </a>
                )}
              </div>
            </div>
            <div className="right-part">
              <div className="hero-image">
                <CommonImage
                  // src={getYoutubeThumbnailUrl(setting?.welcome_video) ?? "/images/home-page/hero.avif"}
                  src={
                    setting?.welcome_video_thumble_url ??
                    "/images/home-page/hero.avif"
                  }
                  alt="Hero Image"
                  className="hero-img"
                />
                <div className="hero-image-playbtn">
                  <a onClick={showModal} className="play-btn">
                    <FaCirclePlay className="play-icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          centered
          width={800}
          className="video-modal"
          styles={{
            body: {
              padding: 0,
            },
          }}
          destroyOnHidden
        >
          <div className="aspect-video w-full">
            <YoutubePlayer url={isModalOpen ? setting?.welcome_video : null} />
          </div>
        </Modal>
      </section>
      {/* )} */}
    </>
  );
}
